export function searchItems(items, query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return items;
  const qNoSpace = q.replace(/\s+/g, "");
  const tokens = q.split(/\s+/).filter(Boolean);
  const scored = [];

  for (const item of items) {
    const name = (item.name || "").toLowerCase();
    const code = (item.short_code || "").toLowerCase();
    const kw = (item.keywords || []).join(" ").toLowerCase();
    const cat = (item.category_name || "").toLowerCase();
    const words = name.split(/\s+/).filter(Boolean);
    const initials = words.map((w) => w[0]).join("");
    const haystack = `${name} ${kw} ${cat}`;

    let score = -1;
    if (name === q) score = 100;
    else if (code && code === qNoSpace) score = 96;
    else if (initials && initials === qNoSpace) score = 92;
    else if (name.startsWith(q)) score = 85;
    else if (code && code.startsWith(qNoSpace)) score = 80;
    else if (initials.length >= 2 && initials.startsWith(qNoSpace)) score = 74;
    else if (tokens.length > 1 && tokens.every((t) => words.some((w) => w.startsWith(t)))) score = 68;
    else if (tokens.every((t) => haystack.includes(t))) score = 55;

    if (score >= 0) scored.push({ item, score });
  }

  scored.sort((a, b) => b.score - a.score || a.item.name.localeCompare(b.item.name));
  return scored.map((s) => s.item);
}
